<template>
  <div class="message-storage-container scrollbar">
    <div
      v-for="(day, i) in dayList"
      :key="i"
      class="mt-2 p-2"
      style="background-color: white">
      <span class="fw-400 font-13 text-grey600">{{ day[0].date }}</span>
      <div class="media-container">
        <div
          v-for="(image, index) in day"
          :key="index"
          class="z2-img-container pointer"
          @click="selectMulti ? selectMessage(image) : openGallery(i, index)">
          <ImageRetry
            :src="image.thumb"
            :retryMax="4" />
          <img
            v-if="image.msgType === 'chat.video.msg'"
            class="icon-play-media"
            src="/assets/icon/icon-play-media.png" />
          <div
            class="btn-forward"
            @click.stop.prevent="forwardMessage(image.raw)">
            <IconV2
              name="v2-share"
              color="#3484F0" />
          </div>
          <div
            class="btn-more"
            @click.stop.prevent="(e) => $emit('showMenu', e, image.raw)">
            <IconV2
              name="el-icon-more"
              color="#3484F0" />
          </div>

          <el-checkbox
            v-if="selectMulti"
            class="checkbox-select-message"
            :value="image.select"
            @change="selectMessage(image)"></el-checkbox>
        </div>
      </div>
    </div>

    <div
      v-if="selectedMessages.length"
      class="px-12 d-flex flex-1 align-items-center justify-content-between border-top"
      style="width: 300px; z-index: 999; position: fixed; bottom: 0; height: 48px; background-color: white">
      <span class="font-14 text-grey600">Đã chọn: {{ selectedMessages.length }}</span>
      <div class="d-flex align-items-center">
        <!-- <div class="z2-btn-status-off z2-btn-circle-small me-2">
          <IconV2 name="v2-image" />
        </div> -->
        <div
          @click="downloadMessage"
          class="z2-btn-status-off z2-btn-circle-small me-2">
          <IconV2 name="v2-import" />
        </div>
        <div
          @click="forwardMultiMessage"
          class="z2-btn-status-off z2-btn-circle-small">
          <IconV2 name="v2-share" />
        </div>
        <el-divider
          direction="vertical"
          class="p-0" />
        <div
          @click="deleteMessage"
          class="z2-btn-status-off z2-btn-circle-small">
          <IconV2
            name="icon-trash"
            color="#CF4343" />
        </div>
      </div>
    </div>

    <div v-if="messages.length >= round * 40" style="display: flex; justify-content: center; align-items: center;" @click="loadMoreImage">
      <el-button class="justify-content-between align-items-center" size="small">Tải thêm</el-button>
    </div>
    <LightBox
      ref="lightbox"
      :media="messages"
      :show-caption="true"
      :show-light-box="false" />
  </div>
</template>

<script>
import { groupByDay } from "../lib/date-util";
import LightBox from "./common/LightBox/LightBox";
import ImageRetry from "./common/ImageRetry.vue";

export default {
  props: ["messages", "conversation", "selectMulti"],
  components: {
    LightBox,
    ImageRetry,
  },
  data() {
    return {
      dayList: [],
      round: 1,
    };
  },
  computed: {
    selectedMessages() {
      const list = [];
      this.dayList.forEach((day) => {
        day.forEach((mess) => {
          if (mess.select) list.push(mess);
        });
      });
      return list;
    },
  },
  watch: {
    messages() {
      this.dayList = groupByDay(this.messages.map((mess) => ({ ...mess, select: false })));
    },
  },
  methods: {
    openGallery(i, index) {
      let idx = 0;
      for (let j = 0; j < i; j++) {
        idx += this.dayList[j].length;
      }
      this.$refs.lightbox.showImage(idx + index);
    },

    forwardMessage(message) {
      this.$bus.$emit("forwardMessage", message);
    },
    forwardMultiMessage() {
      const data = {
        messages: this.selectedMessages.map((m) => m.raw),
        type: 'media',
        isArray: true,
      };
      this.$bus.$emit("forwardMessageMulti", data);
      this.resetSelect();
      this.$emit("reset");
    },
    selectMessage(img) {
      img.select = !img.select;
    },
    resetSelect() {
      this.dayList.forEach((day) => {
        day.forEach((mess) => {
          if (mess.select) mess.select = false;
        });
      });
    },
    downloadMessage() {
      this.selectedMessages.forEach((mess) => {
        let url = JSON.parse(mess.raw.content).href;
        this.download(url);
      });
      this.alert("success", "Tải ảnh về thành công!");
      this.$emit("reset");
      this.resetSelect();
      return;
    },
    download(url) {
      fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
          const objectUrl = URL.createObjectURL(blob);

          const link = document.createElement("a");
          link.href = objectUrl;
          link.download = url;
          document.body.appendChild(link);
          link.click();

          URL.revokeObjectURL(objectUrl);
        });
    },
    deleteMessage() {
      this.selectedMessages.forEach((message) => {
        let request = {
          accountId: this.conversation.accountId,
          toId: this.conversation.toId,
          group: this.conversation.group,
          cliMsgId: message.raw.cliMsgId,
          globalMsgId: message.raw.id.msgId,
          ownerId: this.conversation.toId,
          destId: this.conversation.toId,
        };
        this.$http.post("/api/message/delete", request);
      });
      this.resetSelect();
      this.$emit("reset");
    },
    hanleReplaceLink(data) {
      const FIFTEEN_DAYS_MS = 15 * 24 * 60 * 60 * 1000;
      const now = Date.now();
      this.dayList = this.dayList.map(day => {
        return day.map(d => {
          if (d.raw.id.msgId == data.msgId && (now - d.raw.ts) >= FIFTEEN_DAYS_MS) {
            d.thumb = data.link;
          }
          return d;
        })
      })
      this.messages.forEach(mes => {
        if (mes.raw.id.msgId == data.msgId && (now - mes.raw.ts) >= FIFTEEN_DAYS_MS) {
          mes.thumb = data.link;
          mes.src = mes.thumb;
        }
      })
    },
    loadMoreImage() {
      this.round += 1;
      this.$emit('loadMoreImg', this.round);
    }
  },
  mouted() {
    // this.dayList = groupByDay(this.messages.map((mess) => ({ ...mess, select: false })));
  },
  created() {
    this.$bus.$on("ReplaceLinkEvent", (data) => {this.hanleReplaceLink(data)});
  }
};
</script>

<style lang="scss" scoped>
.message-storage-container {
  height: calc(100vh - 115px) !important;
  overflow-y: auto;
  background-color: #f4f5f9;
}
.checkbox-select-message {
  position: absolute;
  top: 0px;
  left: 6px;
}
</style>